import React, { Component } from 'react';
import classNames from 'classnames';

export class AppProfile extends Component {

    constructor() {
        super();
        this.state = {
            expanded: false
        };
        this.onClick = this.onClick.bind(this);
    }

    onClick(event) {
        this.setState({expanded: !this.state.expanded});
        event.preventDefault();
    }

    cerrarSession=()=>{
        localStorage.removeItem("auth");
        window.location = '/facturacionbanobras';
    }

    render() {
        return  (
            <div className="layout-profile">
                <button className="p-link layout-profile-link" onClick={this.onClick}>
                    <span className="username">Opciones</span>
                    <i className="pi pi-fw pi-cog"/>
                </button>
                <ul className={classNames({'layout-profile-expanded': this.state.expanded})}>
                    <li><button className="p-link" onClick={this.cerrarSession}><i className="pi pi-fw pi-power-off"/><span>Salir</span></button></li>
                </ul>
            </div>
        );
    }
}